/* eslint-disable import/first */

(function () {
  const originalCreateElement = document.createElement;
  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

  if (nonce) {
    document.createElement = function (tagName: any, options: any) {
      const el = originalCreateElement.call(document, tagName, options);
      if (tagName.toLowerCase() === 'style') {
        el.setAttribute('nonce', nonce);
        console.debug('[CSP PATCH] Injected nonce into style element');
      }
      return el;
    };
  } else {
    console.warn('[CSP PATCH] No CSP nonce found in <meta>, skipping patch');
  }
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

function getNonce() {
  return (
    document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || ''
  );
}
function patchMissingStyleNonces() {
  const nonce = getNonce();
  if (!nonce) return;
  [...document.querySelectorAll('style')].forEach((tag, i) => {
    if (!tag.getAttribute('nonce')) {
      tag.setAttribute('nonce', nonce);
    }
  });
}

function setupSecureStyleNonceObserver() {
  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
  if (!nonce) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node: any) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.tagName === 'STYLE' &&
          !node.hasAttribute('nonce')
        ) {
          node.setAttribute('nonce', nonce);
        }
      });
    });
  });

  observer.observe(document.head, { childList: true, subtree: true });
  observer.observe(document.body, { childList: true, subtree: true });
}


window.addEventListener('DOMContentLoaded', () => {
  const nonce = getNonce();

  const cache = createCache({
    key: 'css',
    nonce,
  });

  patchMissingStyleNonces();
  setupSecureStyleNonceObserver();

  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    import.meta.env.VITE_USE_STRICT_MODE === 'true' ? (
      <React.StrictMode>
        <CacheProvider value={cache}>
          <App />
        </CacheProvider>
      </React.StrictMode>
    ) : (
      <CacheProvider value={cache}>
        <App />
      </CacheProvider>
    )
  );
});

